import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function ProtectedRoute({ children, allowedRoles }) {
  const { user, profile, loading } = useAuth();
  const location = useLocation();

  // Still initialising Firebase Auth — show spinner, never redirect yet
  if (loading) {
    return (
      <div className="gm-loading-screen">
        <div className="gm-spinner" />
      </div>
    );
  }

  // Not signed in
  if (!user) {
    return <Navigate to="/scaling/login" state={{ from: location }} replace />;
  }

  // Signed in but profile not loaded yet — keep waiting
  if (!profile) {
    return (
      <div className="gm-loading-screen">
        <div className="gm-spinner" />
      </div>
    );
  }

  // Signed in but wrong role
  if (allowedRoles && !allowedRoles.includes(profile.role)) {
    return <Navigate to="/scaling/unauthorized" replace />;
  }

  return children;
}
